import {
  Box,
  VStack,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from '@chakra-ui/react'
import { colors } from '../../theme/cssVariables'
import { useEffect, useState } from 'react'
import { i18n } from '../../i18nRushB'
import { useNavigate, useParams } from 'react-router-dom'
import { ChevronDownIcon, CheckIcon } from '@chakra-ui/icons'

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'zh', name: '简体中文', flag: '🇨🇳' },
]

const LanguageSettings = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('en')
  const navigate = useNavigate()
  const { lang } = useParams()

  useEffect(() => {
    setSelectedLanguage(lang || 'en')
    i18n.activate(lang || 'en')
  }, [lang])

  const handleLanguageChange = (value: string) => {
    setSelectedLanguage(value)
    i18n.activate(value)
    const currentPath = window.location.pathname
    const newPath = currentPath.replace(lang || '', value)
    navigate(newPath)
  }

  const selectedLang = languages.find((l) => l.code === selectedLanguage)

  return (
    <VStack spacing={8} align="stretch">
      <Box>
        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            w="100%"
            bg={colors.colorB5}
            color={colors.colorB1}
            _hover={{ borderColor: colors.colorA1 }}
            _active={{ bg: colors.colorB5 }}
            variant="solid"
            clipPath={'none'}
          >
            <Flex align="center" gap={2}>
              <Text borderRadius={'50%'}>{selectedLang?.flag}</Text>
              <Text>{selectedLang?.name}</Text>
            </Flex>
          </MenuButton>
          <MenuList w="100%" bg={colors.colorB7} border="none">
            {languages.map((lang) => (
              <MenuItem
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                _hover={{ bg: colors.colorB5 }}
                color={colors.colorB1}
                bg={colors.colorB7}
                w="100%"
                minH={['40px', '48px']}
              >
                <Flex align="center" justify="space-between" width="100%">
                  <Flex align="center" gap={2}>
                    <Text>{lang.flag}</Text>
                    <Text>{lang.name}</Text>
                  </Flex>
                  {selectedLanguage === lang.code && <CheckIcon color="#FFD700" />}
                </Flex>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    </VStack>
  )
}

export default LanguageSettings
